<span [hidden]="!text" *ngIf="text!='N/A'"> {{ text | date: "dd-MMM-yyyy, hh:mm:ss a" }}</span>
<span [hidden]="!text" *ngIf="text=='N/A'"> {{ text }}</span>